import './app'
import './filelist'
import './trash.scss'

window.OCA.Trashbin = OCA.Trashbin
